import * as React from "react";
import { makeStyles } from "@fluentui/react-components";
import { useTextStyles, colors } from "../styles";

const useStyles = makeStyles({
  container: {
    display: "flex",
    alignItems: "center",
    padding: "10px",
    backgroundColor: colors.warningBackground,
    color: colors.warningText,
    fontWeight: 600,
    border: `1.5px solid ${colors.warningBorder}`,
    borderRadius: "5px",
    marginTop: "10px"
  },
  contentWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    marginLeft: "15px"
  },
  button: {
    backgroundColor: colors.warningButtonBackground,
    cursor: "pointer",
    margin: "1px",
    border: `1.5px solid ${colors.warningButtonBackground}`,
    borderRadius: "5px",
    padding: "5px 15px"
  }
});

export interface TCustomNotificationProps {
  label: string;
  btnLabel?: string;
  icon?: React.ReactNode;
  onBtnClick?: React.MouseEventHandler<HTMLButtonElement>;
}

const CustomNotification: React.FC<TCustomNotificationProps> = (props) => {
  const styles = useStyles();
  const textStyles = useTextStyles();

  return (
    <div className={styles.container}>
      {/* prefix icon */}
      {props.icon && <div className="icon-slot">{props.icon}</div>}

      <div className={styles.contentWrapper}>
        <span style={{ marginBottom: "5px", wordBreak: "break-word" }} className={textStyles.warning}>
          {props.label}
        </span>
        {props.onBtnClick && (
          <button onClick={(e) => props.onBtnClick!(e)} className={styles.button}>
            <span className={textStyles.warning}>{props.btnLabel}</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default CustomNotification;
